<div class="row step-header">
  <div class="col col-100">
    <h3>Thanks for signing up!</h3>
    <p>
      We’re so excited to bring Happy Interneting to Columbus. We’ll let you
      know when we arrive in your area and you can schedule your installation.
    </p>
  </div>
</div>
<div class="no-border text-dark">
  <div class="row">
    <div class="col col-100">
      <div class="illustration"></div>
    </div>
    <div class="col col-100">
      <p class="ffs">Find <span>&centerdot;</span> Follow <span>&centerdot;</span> Share</p>
    </div>
    <div class="col col-100 share">
      <a href="https://www.instagram.com/starryinternet/" target="_blank">
        <img src="https://dyajmw2sca9cs.cloudfront.net/signup/img/Instagram_Icon.png" />
      </a>
      <a href="https://twitter.com/starryinternet/" target="_blank">
        <img src="https://dyajmw2sca9cs.cloudfront.net/signup/img/Twitter_Icon.png" />
      </a>
      <a href="https://www.facebook.com/starryinternet/" target="_blank">
        <img src="https://dyajmw2sca9cs.cloudfront.net/signup/img/Facebook_Icon.png" />
      </a>
    </div>
  </div>
</div>
